import { NavigateRoutes } from 'common/constants/app.constant';
import { BaseDataModel, FormMetaModel, HeaderList } from '../../utilitymodels/base.model';

export class CrossSellOpportuinityItem {
    name: string;
    img: string;
    url: string;
    investorList: [];
    schemeList: [];
    text: string;
    remText?: string;
    pageTitle: string;
    toolTipData: string;
    headerList: HeaderList[] = [];
    rowList: string[] = [];
    actionName: string;
    deepLink: boolean = false;
}

export const crossSellUrl = {
    liquid: NavigateRoutes.crossSellOpportunityList + '/liquid',
    lumpsum: NavigateRoutes.crossSellOpportunityList + '/lumpsum',
    equity: NavigateRoutes.crossSellOpportunityList + '/equity',
    debt: NavigateRoutes.crossSellOpportunityList + '/debt',
    dividend: NavigateRoutes.crossSellOpportunityList + '/dividend',
};

export class CrossSellOpportunityModel extends BaseDataModel {
    listInfo: CrossSellOpportuinityItem[] = [
        {
            name: 'Liquid funds only',
            img: 'assets/icon/card/liquid-funds.svg',
            investorList: [],
            schemeList: [],
            url: crossSellUrl.liquid,
            text: 'Investors who have invested in',
            pageTitle: 'Liquid Only Investors',
            toolTipData: 'This report helps you with a list of all the investors who have only liquid investments',
            headerList: [
                {
                    name: 'Investor Details',
                    logo: 'assets/icon/reports/sip-report/user.svg',
                },
                {
                    name: 'Total Market Value',
                    logo: 'assets/icon/card/chart-square-grey.svg',
                },
                {
                    name: 'No. Of Schemes',
                    logo: 'assets/icon/card/schemes.svg',
                },
                {
                    name: 'Actions',
                    logo: '',
                },
            ],
            rowList: [],
            actionName: 'TRANSACT',
            deepLink: false,
        },
        {
            name: 'Equity funds only',
            img: 'assets/icon/card/equity-only-invsetors.svg',
            investorList: [],
            schemeList: [],
            url: crossSellUrl.equity,
            text: 'Investors who have invested in',
            pageTitle: 'Equity Only Investors',
            toolTipData: 'This report helps you with the list of all the investors who have only equity investments',
            headerList: [
                {
                    name: 'Investor Details',
                    logo: 'assets/icon/reports/sip-report/user.svg',
                },
                {
                    name: 'Total Market Value',
                    logo: 'assets/icon/card/chart-square-grey.svg',
                },
                {
                    name: 'No. Of Schemes',
                    logo: 'assets/icon/card/schemes.svg',
                },
                {
                    name: 'Actions',
                    logo: '',
                },
            ],
            rowList: [],
            actionName: 'TRANSACT',
            deepLink: false,
        },
        {
            name: 'Debt funds only',
            img: 'assets/icon/card/debt-funds.svg',
            investorList: [],
            schemeList: [],
            url: crossSellUrl.debt,
            text: 'Investors who have invested in',
            pageTitle: 'Debt Only Investors',
            toolTipData: 'This report helps you with a list of all the investors who have only made debt investments',
            headerList: [
                {
                    name: 'Investor Details',
                    logo: 'assets/icon/reports/sip-report/user.svg',
                },
                {
                    name: 'Total Market Value',
                    logo: 'assets/icon/card/chart-square-grey.svg',
                },
                {
                    name: 'No. Of Schemes',
                    logo: 'assets/icon/card/schemes.svg',
                },
                {
                    name: 'Actions',
                    logo: '',
                },
            ],
            rowList: [],
            actionName: 'TRANSACT',
            deepLink: false,
        },
        {
            name: 'IDCW funds only',
            img: 'assets/icon/card/dividend-fund.svg',
            investorList: [],
            schemeList: [],
            url: crossSellUrl.dividend,
            text: 'Investors who have invested in',
            pageTitle: 'Dividend Only Investors',
            toolTipData: ' This report helps you with the list of all the investors who have only made dividend investments',
            headerList: [
                {
                    name: 'Investor Details',
                    logo: 'assets/icon/reports/sip-report/user.svg',
                },
                {
                    name: 'Total Market Value',
                    logo: 'assets/icon/card/chart-square-grey.svg',
                },
                {
                    name: 'No. Of Schemes',
                    logo: 'assets/icon/card/schemes.svg',
                },
                {
                    name: 'Actions',
                    logo: '',
                },
            ],
            rowList: [],
            actionName: 'TRANSACT',
            deepLink: false,
        },
    ];
    errorModel: any[] = [];
}

export class CrossSellOpportunityMetaModel extends FormMetaModel {
    constructor() {
        super('CrossSell Opportunities', '', false, NavigateRoutes.oppotunity);
    }

    initProperties() {
        return {};
    }
}
